<template>
  <div>
    <!-- 标题栏 -->
    <div class="searchBox">
      <div>
        <el-input v-model="keyword" placeholder="人员" style="width: 250px" size="small" clearable></el-input>
        <el-button type="primary" size="small" style="margin-left: 10px" @click="search"><i class="el-icon-search" style="margin-right: 5px"></i>搜索</el-button>
        <el-button size="small" @click="reset"><i class="el-icon-refresh-left" style="margin-right: 5px"></i>重置</el-button>
        <el-date-picker v-model="today" type="month" placeholder="选择日期" @change="search"
          :clearable="false" :editable="false" style="margin-left: 10px;"></el-date-picker>
      </div>
      <div>
        <el-button type="success" size="small" style="margin-left: 10px" @click="add"><i class="el-icon-plus" style="margin-right: 5px"></i>新增</el-button>
      </div>
    </div>

    <div class="mainBox" style="display: flex; padding: 0; height: 100%">
      <div style="width: calc(100%); padding: 20px; height: calc(100vh - 50px - 113px)" v-loading="listLoading">
        <el-table :data="list" element-loading-text="Loading" fit highlight-current-row border height="calc(100% - 72px)" style="width: 100%">
          <el-table-column align="center" label="日期" min-width="100" prop="riqi"></el-table-column>
          <el-table-column align="center" label="姓名" min-width="100" prop="renyuan"></el-table-column>
          <el-table-column align="center" label="工种" min-width="100" prop="gongzhong"></el-table-column>
          <el-table-column align="center" label="应出勤天数" min-width="100" prop="yingchuqin"></el-table-column>
          <el-table-column align="center" label="实际出勤天数" min-width="100" prop="shijichuqin"></el-table-column>
          <el-table-column align="center" label="计件工资" min-width="100" prop="jijiangongzi"></el-table-column>
          <el-table-column align="center" label="临时用工费用" min-width="100" prop="linshiyonggong"></el-table-column>
          <el-table-column align="center" label="借调工资" min-width="100" prop="jiediaogongzi"></el-table-column>
          <el-table-column align="center" label="保底工资" min-width="100" prop="baodigongzi"></el-table-column>
          <el-table-column align="center" label="补上月工资" min-width="100" prop="bushangyue"></el-table-column>
          <el-table-column align="center" label="补助" min-width="100" prop="buzhu"></el-table-column>
          <el-table-column align="center" label="餐补" min-width="100" prop="canbu"></el-table-column>
          <el-table-column align="center" label="加班费" min-width="100" prop="jiabanfei"></el-table-column>
          <el-table-column align="center" label="其他补助" min-width="100" prop="qitabuzhu"></el-table-column>
          <el-table-column align="center" label="计件工资补助" min-width="100" prop="jijiangongzibuzhu"></el-table-column>
          <el-table-column align="center" label="公积金扣款" min-width="100" prop="gongjijinkoukuan"></el-table-column>
          <el-table-column align="center" label="其他扣款" min-width="100" prop="qitakoukuan"></el-table-column>
          <el-table-column align="center" label="保险补贴" min-width="100" prop="baoxianbutie"></el-table-column>
          <el-table-column align="center" label="8%(养老)" min-width="100" prop="yanglao"></el-table-column>
          <el-table-column align="center" label="0.5%(失业)" min-width="100" prop="shiye"></el-table-column>
          <el-table-column align="center" label="2%(医疗)" min-width="100" prop="yiliao"></el-table-column>
          <el-table-column align="center" label="重大疾病" min-width="100" prop="zhongdajibing"></el-table-column>
          <el-table-column align="center" label="公积金8%" min-width="100" prop="gongjijin"></el-table-column>
          <el-table-column align="center" label="五险一金其他" min-width="100" prop="wuxianqita"></el-table-column>
          <el-table-column align="center" label="个人所得税" min-width="100" prop="suodeshui"></el-table-column>
          <el-table-column align="center" label="保险差额" min-width="100" prop="baoxianchae"></el-table-column>
          <el-table-column align="center" label="领取人核对" min-width="100" prop="lingquren"></el-table-column>
          
          <el-table-column align="center" label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="edit(scope.row.id)">编辑</el-button>
              <el-button type="text" @click="del(scope.row.id)" style="color: #f56c6c">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="padding: 20px; text-align: center">
          <el-pagination
            background
            layout="total, sizes,prev, pager, next, jumper"
            @size-change="pageSizeChange"
            :total="total"
            @current-change="pageChange"
            :current-page="pageNum"
            :page-size="pageSize"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加修改弹窗 -->
    <el-dialog title="编辑" :visible.sync="editModal">
      <el-form :model="editForm" ref="EditForm" label-width="150px" :rules="rules">
        <el-form-item label="日期" prop="riqi">
          <el-date-picker v-model="editForm.riqi" value-format="timestamp"
            type="month" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="姓名" prop="renyuan">
          <el-select v-model="orderValue" filterable placeholder="请选择"
            @change="orderChange" style="width: 600px;">
            <el-option v-for="item in orderSelectList"
              :key="item.renyuan+'_'+item.gongzhong+'_'+item.yingchuqin"
              :label="item.renyuan+'_'+item.gongzhong+'_'+item.yingchuqin"
              :value="item.renyuan+'_'+item.gongzhong+'_'+item.yingchuqin">
            </el-option>
          </el-select>
          <el-input v-model="editForm.renyuan" style="margin-right: 10px;"></el-input>
        </el-form-item>
        <el-form-item label="工种" prop="gongzhong">
          <el-input v-model="editForm.gongzhong"></el-input>
        </el-form-item> -->
        <el-form-item label="人员" prop="renyuan">
          <div style="display: flex;">
            <el-input v-model="editForm.renyuan" style="margin-right: 10px;"></el-input>
            <el-select v-model="editForm.renyuan" multiple filterable placeholder="请选择" style="width: 400px;">
              <el-option v-for="(item,index) in memberSelectList"
                :key="index" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="职位" prop="gongzhong">
          <div style="display: flex;">
            <el-input v-model="editForm.gongzhong" style="margin-right: 10px;"></el-input>
            <el-select v-model="editForm.gongzhong" filterable placeholder="请选择" style="width: 400px;">
              <el-option v-for="(item,index) in zhiweiSelectList"
                :key="index" :label="item.zhiwei" :value="item.zhiwei">
              </el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="应出勤天数" prop="yingchuqin">
          <el-input-number v-model="editForm.yingchuqin" :precision="2" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="实际出勤天数" prop="shijichuqin">
          <el-input-number v-model="editForm.shijichuqin" :precision="2" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="计件工资" prop="jijiangongzi">
          <el-input-number v-model="editForm.jijiangongzi" :precision="2" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="临时用工费用" prop="linshiyonggong">
          <el-input-number v-model="editForm.linshiyonggong" :precision="2" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="借调工资" prop="jiediaogongzi">
          <el-input-number v-model="editForm.jiediaogongzi" :precision="2" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="保底工资" prop="baodigongzi">
          <el-input-number v-model="editForm.baodigongzi" :precision="2" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="补上月工资" prop="bushangyue">
          <el-input-number v-model="editForm.bushangyue" :precision="2" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="补助" prop="buzhu">
          <el-input-number v-model="editForm.buzhu" :precision="2" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="餐补" prop="canbu">
          <el-input-number v-model="editForm.canbu" :precision="2" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="加班费" prop="jiabanfei">
          <el-input-number v-model="editForm.jiabanfei" :precision="2" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="其他补助" prop="qitabuzhu">
          <el-input-number v-model="editForm.qitabuzhu" :precision="2" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="计件工资补助" prop="jijiangongzibuzhu">
          <el-input-number v-model="editForm.jijiangongzibuzhu" :precision="2" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="公积金扣款" prop="gongjijinkoukuan">
          <el-input-number v-model="editForm.gongjijinkoukuan" :precision="2" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="其他扣款" prop="qitakoukuan">
          <el-input-number v-model="editForm.qitakoukuan" :precision="2" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="保险补贴" prop="baoxianbutie">
          <el-input-number v-model="editForm.baoxianbutie" :precision="2" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="8%(养老)" prop="yanglao">
          <el-input-number v-model="editForm.yanglao" :precision="2" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="0.5%(失业)" prop="shiye">
          <el-input-number v-model="editForm.shiye" :precision="2" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="2%(医疗)" prop="yiliao">
          <el-input-number v-model="editForm.yiliao" :precision="2" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="重大疾病" prop="zhongdajibing">
          <el-input-number v-model="editForm.zhongdajibing" :precision="2" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="公积金8%" prop="gongjijin">
          <el-input-number v-model="editForm.gongjijin" :precision="2" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="五险一金其他" prop="wuxianqita">
          <el-input-number v-model="editForm.wuxianqita" :precision="2" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="个人所得税" prop="suodeshui">
          <el-input-number v-model="editForm.suodeshui" :precision="2" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="保险差额" prop="baoxianchae">
          <el-input-number v-model="editForm.baoxianchae" :precision="2" :step="1" :max="100000000"></el-input-number>
        </el-form-item>
        <el-form-item label="领取人核对" prop="lingquren">
          <el-input v-model="editForm.lingquren"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editModal = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
const editFormData = () => {
  return {
    riqi: '',
    renyuan: "",
    gongzhong: "",
    yingchuqin: 0,
    shijichuqin: 0,
    jijiangongzi: 0,
    linshiyonggong: 0,
    jiediaogongzi: 0,
    baodigongzi: 0,
    bushangyue: 0,
    buzhu: 0,
    canbu: 0,
    jiabanfei: 0,
    jijiangongzibuzhu: 0,
    qitabuzhu: 0,
    gongjijinkoukuan: 0,
    qitakoukuan: 0,
    baoxianbutie: 0,
    yanglao: 0,
    shiye: 0,
    yiliao: 0,
    zhongdajibing: 0,
    gongjijin: 0,
    wuxianqita: 0,
    suodeshui: 0,
    baoxianchae: 0,
    lingquren: ""
  }
}
export default {
  data() {
    return {
      url: this.$host,
      list: null,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      listLoading: true,
      keyword: "",
      keywordType: 1,
      editModal: false,
      editForm: editFormData(),
      rules: {
        
      },
      sf: '',
      orderSelectList: [],
      gongxuSelectList: [],
      orderValue: '',
      gongxuValue: '',
      memberSelectList: [],
      zhiweiSelectList: [],
      today: '',
    }
  },

  created() {
    this.sf = localStorage.sf
    this.getList()
    this.getSelectList()
    this.getMemberSelectList()
    this.getZhiweiSelectList()
  },

  methods: {
    orderChange(e) {
      let arr = e.split('_')
      for(let i in this.orderSelectList) {
        if(this.orderSelectList[i].renyuan==arr[0]&&this.orderSelectList[i].gongzhong==arr[1]
          &&this.orderSelectList[i].yingchuqin==arr[2]) {
          this.editForm.renyuan = this.orderSelectList[i].renyuan
          this.editForm.gongzhong = this.orderSelectList[i].gongzhong
          this.editForm.yingchuqin = this.orderSelectList[i].yingchuqin
          
        }
      }
    },
    
    getSelectList() {
      this.$request.post('/index.php/admin/Gongzimodel/hanjieyueMbSelect').then((res) => {
        this.orderSelectList = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    
    getMemberSelectList() {
      this.$request.post('/index.php/admin/admin/memberSelect').then((res) => {
        this.memberSelectList = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    
    getZhiweiSelectList() {
      this.$request.post('/index.php/admin/admin/zhiweiSelect').then((res) => {
        this.zhiweiSelectList = res.data.data
      }).catch(err => {
        console.log(err)
      })
    },
    
    search() {
      this.pageNum = 1
      this.getList()
    },
    
    reset() {
      this.keyword = ""
      this.today = ''
      this.search()
    },
    
    add() {
      let form = JSON.parse(JSON.stringify(this.editForm))
      this.editForm = JSON.parse(JSON.stringify(editFormData()))
      this.editForm.renyuan = form.renyuan
      this.editForm.gongzhong = form.gongzhong
      this.editForm.riqi = form.riqi
      this.editModal = true
    },

    edit(id) {
      this.$request.post('/index.php/admin/gongzi/hanjieyueInfo', {id: id}).then((res) => {
        this.editForm = res.data.data
        this.editForm.renyuan = [this.editForm.renyuan]
        this.editForm.riqi = parseInt(this.editForm.riqi*1000)
        this.editModal = true
      }).catch(err => {
        console.log(err)
      })
    },

    del(id) {
      this.$confirm("请确认是否删除该条信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$request.post('/index.php/admin/gongzi/hanjieyueDel', {id: id}).then((res) => {
          this.$message.success(res.data.msg)
          this.getList()
        }).catch(err => {
          console.log(err)
        })
      })
    },

    save() {
      this.$refs["EditForm"].validate((valid) => {
        if (valid) {
          let data = JSON.parse(JSON.stringify(this.editForm))
          data.riqi = parseInt(data.riqi/1000)
          data.account = localStorage.account
          this.$request.post('/index.php/admin/gongzi/hanjieyueSave', data).then((res) => {
            this.$message.success(res.data.msg)
            this.editModal = false
            this.getList()
          }).catch(err => {
            console.log(err)
          })
        }
      })
    },


    pageChange(page) {
      this.pageNum = page
      this.getList()
    },

    pageSizeChange(size) {
      this.pageSize = size
      this.getList()
    },

    getList() {
      this.listLoading = true
      let data = {
        page: this.pageNum,
        num: this.pageSize,
      }
      if(this.keyword) {
        data.keyword = this.keyword
      }
      if(this.today) {
        data.year = this.today.getFullYear()
        data.month = this.today.getMonth()+1
      }
      this.$request.post('/index.php/admin/gongzi/hanjieyueList', data).then((res) => {
        this.list = res.data.data
        this.total = res.data.count
        this.listLoading = false
      }).catch(err => {
        console.log(err)
      })
    },
  },
}
</script>
<style scoped="">

</style>
